import React from 'react'

export default function Book() {
  return (
    <svg width="25" height="29" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#DEF1D9"
          d="M0 1.93v25.104h5.505l-2.367-2.907 17.641-.047V1.93z"
        />
        <path
          stroke="#636466"
          strokeWidth="1.6"
          d="M2.77 24.314l2.892 3.097h18.656"
        />
        <path
          stroke="#636466"
          strokeWidth="1.6"
          d="M23.926 27.41V4.63h-3.008"
        />
        <path fill="#FFF" d="M2.77 24.245h18.01V1H2.77z" />
        <path
          stroke="#636466"
          strokeWidth="1.6"
          d="M2.77 24.245h18.01V1H2.77zM8.312 5.649h8.773M7.388 5.649h-.923M8.312 7.973h8.773M7.388 7.973h-.923M8.312 10.298h8.773M7.388 10.298h-.923"
        />
      </g>
    </svg>
  )
}
